module.exports = __webpack_public_path__ + "static/img/farmerTab.d62bb26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/farmerTab.jpg
// module id = nxnl
// module chunks = 4